import { rankingItems } from './mockData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 mb-4">
              <i className="ri-trophy-line text-primary-600 text-sm"></i>
              <span className="text-primary-700 text-xs font-medium">热度排行</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              热门榜单
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              根据观看热度与用户评分实时更新的影视排行榜
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-200/70 transition-colors ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200' : ''
                }`}
              >
                <div className={`w-10 h-10 flex items-center justify-center rounded-xl font-heading text-lg font-bold flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-bold text-foreground-900 text-sm md:text-base truncate">
                      {item.title}
                    </h3>
                    {item.trend === 'new' && (
                      <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">NEW</span>
                    )}
                    {item.trend === 'hot' && (
                      <span className="inline-block px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">HOT</span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-400">{item.tag}</span>
                </div>

                <div className="flex items-center gap-1.5 flex-shrink-0">
                  <i className={`text-sm ${
                    item.trend === 'up' || item.trend === 'new' ? 'ri-arrow-up-line text-primary-500' :
                    item.trend === 'hot' ? 'ri-fire-line text-accent-500' : 'ri-subtract-line text-foreground-400'
                  }`}></i>
                  <span className="font-heading text-lg font-bold text-foreground-900">{item.hot}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}